"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _richTextField = require("../../lib/richTextField");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _FinproProfileUtility = require("./FinproProfileUtility");
var _DisclosureModal = _interopRequireDefault(require("./DisclosureModal"));
var _CalendlyModal = _interopRequireDefault(require("./CalendlyModal"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 *  A react component to display agent profile without hero
 *
 * @param {object} props The properties passed into the object
 * @param {object} props Fields to render
 *
 * @returns {React.ReactElement} agent profile
 */
function AgentProfile(props) {
  if (!props) {
    return null;
  }
  var socialLinksAvailable = !(0, _lodash.isEmpty)(props.socialAppList.facebook) || !(0, _lodash.isEmpty)(props.socialAppList.linkedin) || !(0, _lodash.isEmpty)(props.socialAppList.twitter);

  // Calendly Modal event
  var [showCalendlyModal, setShowCalendlyModal] = (0, _react.useState)(false);
  var [calendlyLink, setCalendlyLink] = (0, _react.useState)('');
  var handleCalendlyModalShow = calendlyLink => {
    if (!((0, _lodash.isEmpty)(calendlyLink) || (0, _lodash.isNil)(calendlyLink))) {
      setShowCalendlyModal(true);
      setCalendlyLink(calendlyLink);
    }
  };
  var handleCalendlyModalClose = () => {
    setShowCalendlyModal(false);
    setCalendlyLink('');
  };
  var GetGADislaimer = () => {
    if (props.isManagingAssociate) {
      return /*#__PURE__*/_react.default.createElement("p", null, "By submitting this request, I agree to receive e-mails and phone calls using automated technology from MassMutual, its financial professionals, affiliates or vendors on its behalf regarding MassMutual products and services, at the e-mail address and phone number(s) above, even if it is for a wireless phone. I understand I can contact a local financial professional directly to make a purchase without consenting to receive calls from MassMutual.");
    } else return null;
  };
  var GetPrimaryData = () => {
    var agency = props.agency;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.OfficeTitleLink, {
      officeTitle: agency.agencyName,
      titleSize: 'h3',
      officeLink: agency.agencyUrl,
      className: 'card-title'
    }), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetAddress, _extends({}, agency.location, {
      schema: true
    })), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetGoogleMapLink, agency.location), !((0, _lodash.isEmpty)(agency.agencyWebsiteUrl) && (0, _lodash.isEmpty)(props.personalWebsite)) && /*#__PURE__*/_react.default.createElement("div", {
      className: "link-padding"
    }, !(0, _lodash.isEmpty)(props.personalWebsite) && /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'inline',
      target: '_blank',
      label: 'Visit My Personal Website',
      icon: 'icon-external-link',
      iconDirection: 'left',
      href: props.personalWebsite
    }), !(0, _lodash.isEmpty)(agency.agencyWebsiteUrl) && /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'inline',
      target: '_blank',
      label: 'Visit Agency Website',
      icon: 'icon-external-link',
      iconDirection: 'left',
      href: agency.agencyWebsiteUrl
    })), (socialLinksAvailable || !(0, _lodash.isEmpty)(props.calendly)) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
      className: "finpro-social-link"
    }, socialLinksAvailable && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 6,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetSocialLinks, props.socialAppList)), !(0, _lodash.isEmpty)(props.calendly) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 6,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
      buttonType: 'primary',
      label: 'Schedule an Appointment',
      dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.CALENDLY_CTA_LABEL, props.agentUrl),
      onClick: () => handleCalendlyModalShow(props.calendly),
      icon: 'icon-external-link',
      iconDirection: 'right'
    }), /*#__PURE__*/_react.default.createElement(_CalendlyModal.default, {
      show: showCalendlyModal,
      navigateLink: calendlyLink,
      onModelClose: handleCalendlyModalClose
    })))), /*#__PURE__*/_react.default.createElement("hr", null));
  };
  var GetAgentBio = () => {
    var agentBio = (0, _lodash.get)(props, 'agentBio');
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-md icon-user-black"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "subtitle"
    }, "Professional Story")), /*#__PURE__*/_react.default.createElement("div", null, (0, _richTextField.parseHTML)(agentBio.bioText), agentBio.bioTags && (0, _lodash.map)(agentBio.bioTags, (bioTag, tagIndex) => {
      return /*#__PURE__*/_react.default.createElement("section", {
        key: "bio-".concat(tagIndex)
      }, /*#__PURE__*/_react.default.createElement("h4", null, bioTag.key), /*#__PURE__*/_react.default.createElement("p", null, bioTag.value, " "));
    }))), /*#__PURE__*/_react.default.createElement("hr", null));
  };
  var GetLanguages = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-md icon-web-black"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "subtitle"
    }, "Languages: "), /*#__PURE__*/_react.default.createElement("span", {
      className: "p"
    }, props.languages.join(', '), " "))), /*#__PURE__*/_react.default.createElement("hr", null));
  };
  var GetCredentials = () => {
    if (props.designations && props.designations.length > 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-md icon-college-black"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "subtitle"
      }, "Credentials: "), /*#__PURE__*/_react.default.createElement("span", {
        className: "p"
      }, (0, _richTextField.parseHTML)(props.designations.join(', ')), " "))), /*#__PURE__*/_react.default.createElement("hr", null));
    } else return null;
  };
  var GetSpecialites = () => {
    if (props.specialties && props.specialties.length > 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-md icon-college-black"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "subtitle"
      }, "Specialties:"), /*#__PURE__*/_react.default.createElement("span", {
        className: "p"
      }, props.specialties.join(', '), " "))), /*#__PURE__*/_react.default.createElement("hr", null));
    } else return null;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "finpro-profile-section"
  }, /*#__PURE__*/_react.default.createElement(GetPrimaryData, null), /*#__PURE__*/_react.default.createElement(GetAgentBio, null), /*#__PURE__*/_react.default.createElement(GetLanguages, null), /*#__PURE__*/_react.default.createElement(GetCredentials, null), /*#__PURE__*/_react.default.createElement(GetSpecialites, null), props.isRegistered && /*#__PURE__*/_react.default.createElement("p", null, "Check the background of this investment professional on", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://brokercheck.finra.org",
    rel: "noopener noreferrer",
    target: "_blank"
  }, "FINRA's BrokerCheck")), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, _extends({}, props.disclosures, {
    userType: 'agent',
    id: 'modal-disclosures',
    label: "See ".concat(props.firstName, "'s Licenses and Disclosures")
  })), /*#__PURE__*/_react.default.createElement(GetGADislaimer, null));
}
var _default = exports.default = AgentProfile;